import type { LightModeEntry } from '@cnapse/shared/schemas.js';

export function formatLightingModesSummary(modes: LightModeEntry[]): string {
  return modes.map((m) => `Mode ${m.mode} @ ${m.startPower}`).join(', ');
}
